module.exports = __webpack_public_path__ + "static/XpertHRM-787b774910bc642da88000acb4ce5436.jpg";